


























import Vue from 'vue';

export default Vue.extend({
  name: 'Navbar',
  methods: {
    setLang(lang: string): void {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    },
  },
});
